import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

/******************************************************************
 * 파일명 : frontend2\src\components\bootstrap\ButtonBasic.js
 * 설명 : 메타페이와 같은 보라색 기본 버튼에 사용될 컴포넌트
 ******************************************************************/

const ButtonBasic = forwardRef(
	({ children = null, className = null, color = 'primary', isLight = false, rounded = 'null', ...props }, ref) => (
		<Button
			ref={ref}
			className={`btn_basic ${className || ''}`.trim()}
			color={color}
			isLight={isLight}
			rounded={rounded}
			{...props}
		>
			{children}
		</Button>
	),
);

ButtonBasic.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	color: PropTypes.string,
	isLight: PropTypes.bool,
	rounded: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ButtonBasic;